var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 40 40",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08157 8.75H6.25V10H8.11383L11.3598 24.375H11.3566C11.614 25.1032 12.3085 25.625 13.1249 25.625H28.1249V24.375H29.375L31.8749 14.375L30.625 13.125H11.2816C11.2515 13.125 11.2243 13.1252 11.1997 13.1255C11.1569 13.1259 11.1219 13.1262 11.0934 13.125H10.9692L11.2499 14.375H30.625L28.1249 24.375H12.6098L9.08157 8.75ZM15.625 28.75C15.625 29.4404 15.0654 30 14.375 30C13.6846 30 13.125 29.4404 13.125 28.75C13.125 28.0596 13.6846 27.5 14.375 27.5C15.0654 27.5 15.625 28.0596 15.625 28.75ZM16.875 28.75C16.875 30.1307 15.7557 31.25 14.375 31.25C12.9943 31.25 11.875 30.1307 11.875 28.75C11.875 27.3693 12.9943 26.25 14.375 26.25C15.7557 26.25 16.875 27.3693 16.875 28.75ZM25.625 30C26.3154 30 26.875 29.4404 26.875 28.75C26.875 28.0596 26.3154 27.5 25.625 27.5C24.9346 27.5 24.375 28.0596 24.375 28.75C24.375 29.4404 24.9346 30 25.625 30ZM25.625 31.25C27.0057 31.25 28.125 30.1307 28.125 28.75C28.125 27.3693 27.0057 26.25 25.625 26.25C24.2443 26.25 23.125 27.3693 23.125 28.75C23.125 30.1307 24.2443 31.25 25.625 31.25ZM22.4372 16.25L23.3211 17.1339L21.2944 19.1605L23.3211 21.1872L22.4372 22.0711L20.4105 20.0444L18.3839 22.0711L17.5 21.1872L19.5267 19.1605L17.5 17.1339L18.3839 16.25L20.4105 18.2767L22.4372 16.25Z",
    fill: "#5B47FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrders);
export default __webpack_public_path__ + "static/media/no_orders.142dc2b18098626a47b553ff28993aac.svg";
export { ForwardRef as ReactComponent };